import { z } from 'zod'
import { ZSchema } from '../utils/zodSchema'

// Schema for validating suggestion creation.
const suggestionCreationSchema = z.object({
    userId: z.string().min(1, "user's id is Required"),
    subCatTitle: z.string().min(1, "subcategory name is Required"),
    fields: z.array(z.string()).min(1, "fields array is Required")
})



// TODO: UNTESTED: Test 
const suggestionSchemaValidator = new ZSchema({ bodySchema: suggestionCreationSchema })


export { suggestionCreationSchema }
export { suggestionSchemaValidator }
